module.exports = __webpack_public_path__ + "media/images/temp/ribbon-7-a1140fa97bffa2843a7d3d55e21682dd.png";